const OrderValidationError = require('@/lib/Validation/OrderValidationError');

class StaffRefValidator {
    /**
     * @param {CartStasher} cartStasher
     * @param {DialogService} dialogService
     */
    constructor(
        cartStasher,
        dialogService
    ) {
        this.cartStasher = cartStasher;
        this.dialogService = dialogService;
    }

    /**
     * Checks if a staff ref is entered if required, and if it is unique.
     * If it is not unique it shows an alert about saving a cart with a duplicate ref.
     *
     * @param {Cart} cart
     * @param {string} newRef
     * @param {boolean} [required]
     *
     * @return {Promise}
     */
    validateStaffRef(cart, newRef, required = false) {
        if (!newRef && required) {
            return Promise.reject(new Error('A reference is required.'));
        }

        if (cart.ignoreDuplicateRef) {
            // User has previously selected to ignore a duplicate ref / not to merge, so honour that choice.
            return Promise.resolve();
        }

        // Check for an existing cart with the same reference.
        return this.findExistingStashWithRef(newRef)
            .then((existingStashWithRef) => {
                // If the reference is only being set and it is a duplicate we just display
                // a yes/no dialog to confirm using a duplicate ref.
                if (existingStashWithRef) {
                    return this.dialogService.confirm('ORDERS_ON_HOLD.DUPLICATE_REF_ALERT')
                        .then((confirmed) => {
                            if (confirmed) {
                                // Remember on the cart that the user chose to ignore the duplicate ref.
                                cart.ignoreDuplicateRef = true;
                            } else {
                                throw new OrderValidationError(OrderValidationError.DUPLICATE_STAFF_REF);
                            }
                        });
                }

                return true;
            });
    }

    /**
     * @param {Cart} cart
     * @param {string} newRef
     *
     * @returns {Promise}
     */
    setCartStaffRef(cart, newRef) {
        return this.validateStaffRef(cart, newRef)
            .then(() => {
                // Set the reference.
                cart.staffRef = newRef;
            });
    }

    /**
     * Resolves either with one StashedCart with the given staff ref, or null.
     *
     * @param {string} ref
     *
     * @returns {Promise<StashedCart>}
     */
    findExistingStashWithRef(ref) {
        if (!ref) {
            return Promise.resolve(null);
        }

        return this.cartStasher.findByStaffRef(ref)
            .then((existingStashes) => {
                return existingStashes[0] || null;
            });
    }
}

module.exports = StaffRefValidator;
